import { loadRemoteModule } from '@nx/angular/mf';

/**
 * The function loads specific application
 * @param appName - application name that is specified in the workspace
 * @param ngModuleCallback - callback for loading a specific module/function from remote entry
 * @returns module obtained through @param ngModuleCallback param from remote app
 */
export async function loadRemoteModuleAsync(appName: string, ngModuleCallback: (remoteEntryPoint: any) => Promise<any>): Promise<any> {
  try {
    const remoteApp = await loadRemoteModule(appName, './Module');
    const ngModule = ngModuleCallback(remoteApp);

    return ngModule;
  } catch (error) {
    return import('./fallback-module/fallback.module').then(({ FallbackModule }) => FallbackModule);
  }
}
